<template>
  <div class="logo clearfix">
    <div class="img">
      <!-- <img src="@/assets/images/logo.png" alt=""> -->
    </div>
    <div class="title">
      <h1>{{ title }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: ''
    }
  },
  created () {
    let title = JSON.parse(localStorage.user).title
    this.title = (title == null || title == '' || title == 'null') ? '' : title
  }
}
</script>

<style lang="less" scoped>
.logo {
  .img {
    float: left;
    img {
      position: relative;
      top: 14px;
      height: 44px;
    }
  }
  .title {
    float: left;
    padding-left: 24px;
    h1 {
      color: #fff;
      font-size: 22px;
      font-weight: normal;
    }
  }
}
</style>